import { render, staticRenderFns } from "./AddUpdateDialog.vue?vue&type=template&id=f1f6c8b0&scoped=true&"
import script from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateDialog.vue?vue&type=style&index=0&id=f1f6c8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f6c8b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f6c8b0')) {
      api.createRecord('f1f6c8b0', component.options)
    } else {
      api.reload('f1f6c8b0', component.options)
    }
    module.hot.accept("./AddUpdateDialog.vue?vue&type=template&id=f1f6c8b0&scoped=true&", function () {
      api.rerender('f1f6c8b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homePageCopyWriter/components/AddUpdateDialog.vue"
export default component.exports